import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="bg-navy text-white noise-overlay min-h-[70vh] flex items-center py-20">
      <div className="max-w-xl mx-auto px-4 text-center">
        <XCircle className="w-16 h-16 text-bronze mx-auto mb-6" />
        <h1 className="font-heading text-4xl font-bold mb-3">Payment Canceled</h1>
        <p className="font-body text-lg text-gray-300 mb-8">No charge was made. You can restart your payment whenever you're ready.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild className="bg-bronze hover:bg-bronze/90 text-navy rounded-full px-8 py-6 text-lg font-semibold"><Link to="/payments">Return to Payment</Link></Button>
          <Button asChild variant="outline" className="border-white text-white hover:bg-white hover:text-navy rounded-full px-8 py-6 bg-transparent"><Link to="/">Back to Home</Link></Button>
        </div>
      </div>
    </div>
  );
}
